// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nightbot-ScheduledAnnouncement-module__announcementPanel-Avspl {
  position: relative;
  z-index: 10;
}

.nightbot-ScheduledAnnouncement-module__chatterScanIcon-nwbib {
  color: var(--mantine-color-gray-5);
  margin-right: 8px;
}

.nightbot-ScheduledAnnouncement-module__chatterContainer-fx41I {
  width: 100%;
  height: 100%;
  padding: 12px;
  border-radius: var(--mantine-radius-xl);
  background-color: var(--mantine-color-gray-1);
}

@supports ((-webkit-mask-image: paint(squircle)) or (mask-image: paint(squircle))) {

.nightbot-ScheduledAnnouncement-module__chatterContainer-fx41I {
    --squircle-smooth: 1;
    --squircle-radius: 96px;
    -webkit-mask-image: paint(squircle);
            mask-image: paint(squircle);
}
  }

.nightbot-ScheduledAnnouncement-module__chatter-ju0au {
  display: flex;
  align-items: center;
}

.nightbot-ScheduledAnnouncement-module__announcementInfo-Wn2U0 {
  display: flex;
  margin-left: 12px;
  flex-direction: column;
  color: var(--mantine-color-gray-9);
  margin-right: auto;
}

.nightbot-ScheduledAnnouncement-module__message-uyNcO {
  color: var(--mantine-color-gray-7);
}

.nightbot-ScheduledAnnouncement-module__logoContainer-J0hUF {
  width: 32px;
  height: 32px;
  display: grid;
  align-items: center;
  justify-items: center;
  place-items: center;
  border-radius: var(--mantine-radius-md);
  background-color: var(--mantine-color-indigo-7);
}

@supports ((-webkit-mask-image: paint(squircle)) or (mask-image: paint(squircle))) {

.nightbot-ScheduledAnnouncement-module__logoContainer-J0hUF {
    --squircle-smooth: 1;
    --squircle-radius: 96px;
    -webkit-mask-image: paint(squircle);
            mask-image: paint(squircle);
}
  }

.nightbot-ScheduledAnnouncement-module__logo-nq8cD {
  color: var(--mantine-color-indigo-0);
  width: 20px;
  height: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/components/landing/ScheduledAnnouncement.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uCAAuC;EACvC,6CAA6C;AAO/C;;AALE;;AAPF;IAQI,oBAAoB;IACpB,uBAAuB;IACvB,mCAA2B;YAA3B,2BAA2B;AAE/B;EADE;;AAGF;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EAAnB,qBAAmB;EAAnB,mBAAmB;EACnB,uCAAuC;EACvC,+CAA+C;AAOjD;;AALE;;AARF;IASI,oBAAoB;IACpB,uBAAuB;IACvB,mCAA2B;YAA3B,2BAA2B;AAE/B;EADE;;AAGF;EACE,oCAAoC;EACpC,WAAW;EACX,YAAY;AACd","sourcesContent":[".announcementPanel {\n  position: relative;\n  z-index: 10;\n}\n\n.chatterScanIcon {\n  color: var(--mantine-color-gray-5);\n  margin-right: 8px;\n}\n\n.chatterContainer {\n  width: 100%;\n  height: 100%;\n  padding: 12px;\n  border-radius: var(--mantine-radius-xl);\n  background-color: var(--mantine-color-gray-1);\n\n  @supports (mask-image: paint(squircle)) {\n    --squircle-smooth: 1;\n    --squircle-radius: 96px;\n    mask-image: paint(squircle);\n  }\n}\n\n.chatter {\n  display: flex;\n  align-items: center;\n}\n\n.announcementInfo {\n  display: flex;\n  margin-left: 12px;\n  flex-direction: column;\n  color: var(--mantine-color-gray-9);\n  margin-right: auto;\n}\n\n.message {\n  color: var(--mantine-color-gray-7);\n}\n\n.logoContainer {\n  width: 32px;\n  height: 32px;\n  display: grid;\n  place-items: center;\n  border-radius: var(--mantine-radius-md);\n  background-color: var(--mantine-color-indigo-7);\n\n  @supports (mask-image: paint(squircle)) {\n    --squircle-smooth: 1;\n    --squircle-radius: 96px;\n    mask-image: paint(squircle);\n  }\n}\n\n.logo {\n  color: var(--mantine-color-indigo-0);\n  width: 20px;\n  height: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"announcementPanel": `nightbot-ScheduledAnnouncement-module__announcementPanel-Avspl`,
	"chatterScanIcon": `nightbot-ScheduledAnnouncement-module__chatterScanIcon-nwbib`,
	"chatterContainer": `nightbot-ScheduledAnnouncement-module__chatterContainer-fx41I`,
	"chatter": `nightbot-ScheduledAnnouncement-module__chatter-ju0au`,
	"announcementInfo": `nightbot-ScheduledAnnouncement-module__announcementInfo-Wn2U0`,
	"message": `nightbot-ScheduledAnnouncement-module__message-uyNcO`,
	"logoContainer": `nightbot-ScheduledAnnouncement-module__logoContainer-J0hUF`,
	"logo": `nightbot-ScheduledAnnouncement-module__logo-nq8cD`
};
export default ___CSS_LOADER_EXPORT___;
